var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 556,
    width: 29,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    transform: "translate(-370 -556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.023 561.438 395.981 561.438 395.981 565.062 373.023 565.062Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.929 566.271 373.929 579.562 395.075 579.562 395.075 566.271ZM387.523 571.104 381.481 571.104 381.481 568.688 387.523 568.688Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBox);
export default __webpack_public_path__ + "static/media/nav-box.cb920a8382b628d6f8b20cb19b42771f.svg";
export { ForwardRef as ReactComponent };